export const RESET_ONE_REDUCER_STATE = 'RESET_ONE_REDUCER_STATE'
export const RESET_ALL_REDUCER_STATE = 'RESET_ALL_REDUCER_STATE'
